import {
  GET_DOCUMENT_TYPE_REQUEST,
  GET_DOCUMENT_TYPE_SUCCESS,
  GET_DOCUMENT_TYPE_FAILURE,
  GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST,
  GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS,
  GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE,
} from "./documentTypeTypes";

const initialState = {
  loading: false,
  documentType: [],
  error: "",
};

const getDocumentTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DOCUMENT_TYPE_SUCCESS:
      return {
        loading: false,
        documentType: action.payload,
        error: "",
      };
    case GET_DOCUMENT_TYPE_FAILURE:
      return {
        loading: false,
        documentType: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

const initialStateWithPagination = {
  loading: false,
  documentType: [],
  error: "",
};

const getDocumentTypeWithPaginationReducer = (
  state = initialStateWithPagination,
  action
) => {
  switch (action.type) {
    case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
      return {
        loading: false,
        documentType: action.payload,
        error: "",
      };
    case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
      return {
        loading: false,
        documentType: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getDocumentTypeReducer, getDocumentTypeWithPaginationReducer };
